export const thousandFormat = (value: any) => {
  if (isNaN(parseFloat(value)) || !isFinite(value)) {
    return '0';
  }

  value = value.toString();
  const parsedValue = parseFloat(value);
  const isNegative = parsedValue < 0;
  const fractionalPart = value.substring(value.indexOf('.'));
  const integerPart = Math.abs(Math.floor(parsedValue));

  const reversed = String(integerPart)
    .split('')
    .reverse()
    .join('')
    .match(/.{1,3}/g)!
    .join(',');

  return (
    (isNegative ? '-' : '') +
    reversed
      .split('')
      .reverse()
      .join('') +
    (fractionalPart[0] === '.' ? fractionalPart : '')
  );
};

export const parseIntFromThousandFormat = (value: string) => {
  return parseInt(value.split(',').join(''), 10);
};

export const formatAsPercentage = (value: any) => {
  if (isNaN(parseFloat(value)) || !isFinite(value)) {
    return '0';
  }

  const PERCENTAGE_FACTOR = 100;
  const DIGIT_AFTER_POINT = 3;
  value = value.toString();
  const parsedValue = parseFloat(value);
  return (parsedValue * PERCENTAGE_FACTOR).toFixed(DIGIT_AFTER_POINT);
};
